var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4291 1.00721C39.4291 1.00719 39.4291 1.00718 39.4291 1.00716C39.5094 0.330947 40.4906 0.330947 40.571 1.00716C40.571 1.00718 40.571 1.00719 40.571 1.00721L41.8295 11.6137C43.4818 25.5391 54.4609 36.5182 68.3862 38.1705L78.9927 39.4291C79.6691 39.5094 79.6691 40.4906 78.9927 40.571L68.3862 41.8295C54.4609 43.4818 43.4818 54.4609 41.8295 68.3862L40.571 78.9927C40.4906 79.6691 39.5094 79.6691 39.4291 78.9927L38.1705 68.3862C36.5182 54.4609 25.5391 43.4818 11.6137 41.8295L1.00721 40.571C1.00719 40.571 1.00718 40.571 1.00716 40.571C0.330947 40.4906 0.330947 39.5094 1.00716 39.4291C1.00718 39.4291 1.00719 39.4291 1.00721 39.4291L11.6137 38.1705C25.5391 36.5182 36.5182 25.5391 38.1705 11.6137L39.4291 1.00721Z",
    stroke: "#23ECD0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.a518aabeab08e17fa4386ebbd2e0ccf7.svg";
export { ForwardRef as ReactComponent };